import { z } from "zod";
import { yearSchema } from "./util";

export const galleryPhotoAlbumSchema = z.object({
	id: z.string().transform((id) => parseInt(id)),
	bg: z.string().nullable(),
	pic: z.string().nullable(),
	pic_mini: z.string().nullable(),
	name: z.string(),
	title: z.string(),
	year: yearSchema,
	detail: z.object({
		name: z.string(),
		images: z.array(z.string()),
		video: z.null(),
		count: z.number(),
		title_count: z.string(),
		city: z.string().nullable().optional(),
		year: yearSchema,
		detail_text: z.string().optional(),
	}),
});
export const galleryPhotoAlbumsSchema = z.array(galleryPhotoAlbumSchema);

export type GalleryPhotoAlbumType = z.infer<typeof galleryPhotoAlbumSchema>;
